module.exports = __webpack_public_path__ + "static/media/cw-brien.e37a3845.png";